module.exports = __webpack_public_path__ + "static/1-67c4b33d937494b127f45f851c35d4ba.png";